/* eslint quote-props: 0 */  // --> OFF
/* eslint quotes: 0 */  // --> OFF
import { StringTableCommon } from './common/StringTableCommon'
export const StringTable = [
  ...StringTableCommon,
  {
    "key": "sampleStrKey",
    "en": "Sample"
  },
  {
    "key": "productComparisonFailed",
    "en": "Not enough data to compare"
  },
  {
    "key": "defaultErrMsg",
    "en": "There are no items that match your query"
  },
  {
    "key": "defaultApiErrMsg",
    "en": "We are experiencing a technical issue. Contact customer care team if problem persists."
  },
  {
    "key": "emptyList",
    "en": "No products found"
  },
  {
    "key": "emptyData",
    "en": "No data available"
  },
  {
    "key": "signUpOffer",
    "en": "Sign-up now to avail exciting offers on this product. Offer valid for a limited period"
  }
]


// WEBPACK FOOTER //
// ./src/StringTable.js